import React from "react";

function AddLinkIcon({
  className,
  isEditable,
}: {
  className: string;
  isEditable: boolean;
}) {
  return (
    <svg className={className} viewBox="0 0 65.981 56">
      <g transform="translate(-19 0.331)">
        <g
          transform="translate(19 -0.331)"
          fill="none"
          strokeWidth="1"
          strokeDasharray="5"
        >
          <circle cx="27.5" cy="27.5" r="27.5" stroke="none" />
          <circle cx="27.5" cy="27.5" r="27" fill="none" />
        </g>
        {isEditable && (
          <g transform="translate(0 119.134)">
            <path
              d="M11,0A11,11,0,1,1,0,11,11,11,0,0,1,11,0Z"
              transform="translate(62.981 -85.577)"
            />
            <text
              transform="translate(68.278 -68.465)"
              fill="#fff"
              fontSize="20"
              stroke="none"
              fontFamily="Quicksand-Medium, Quicksand"
              fontWeight="500"
              letterSpacing="-0.024em"
            >
              <tspan x="0.7" y="0.8" stroke="none">
                +
              </tspan>
            </text>
          </g>
        )}
        <g transform="matrix(0.788, -0.616, 0.616, 0.788, 34.919, 30.573)">
          <path
            d="M14.35,0h3.075a5.125,5.125,0,1,1,0,10.25H14.35m-6.15,0H5.125A5.125,5.125,0,0,1,5.125,0H8.2"
            transform="translate(0)"
            fill="none"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
          />
          <path
            d="M0,0H8.2"
            transform="translate(7.175 5.125)"
            fill="none"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
          />
        </g>
      </g>
    </svg>
  );
}

export { AddLinkIcon };
